<template>
  <div class="menu-page" :style="{background:'#b80000'}">
    <div class="warp-menu main-width">
      <template v-for="(item,index) in menuList" >
        <div class="col-1"
          :key="index"
          @click="onClickMenu(item.index)"
          :class="active == item.index ?' menu-my-bg':''">
          <span>{{ item.title }}</span>
          <span class="head-link-icon" :style="'border-top:15px solid #b80000'"></span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'eventMenu',
  data () {
    return {
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      active: 0,
      menuList: [{
        title: '主页',
        index: 0
      // }, {
      //   title: '新闻',
      //   index: 1
      }, {
        title: '赛事',
        index: 2
      }, {
        title: '运动员榜',
        index: 3
      }, {
        title: '机构榜',
        index: 4
      }]
    }
  },
  computed: {},
  methods: {
    onClickMenu (val) {
      this.active = val
      this.$parent.tabSwitch(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-width {
  width:1200px;
  height:60px;
  margin-left:auto;
  margin-right:auto;
}
.menu-my-bg{
    span{
      font-size:18px;
    }
    .head-link-icon{
      width: 0;
      height: 0;
      border-right: 15px solid transparent;
      border-left: 15px solid transparent;
      position: absolute;
      bottom: -35px;
      left: 0px;
      z-index: 500;
    }
    .menu-child{
      display: block !important;
      top: 60px;
      border-radius: 4px;
      position: absolute;
      .menu-row{
        cursor: pointer;
        &:hover{
          background-color: rgba(255,255,255,0.1) !important;
        }
        padding: 5px 12px;
      }
    }
  }
  .menu-page{
    width: 100%;
    position: absolute;
    top: 70px;
    left: 0;
    z-index: 4;
    color:#fff;
    height:60px;
    font-size: 14px;
    .warp-menu{
        display: flex;
        align-items: center;
        .menu-child{
          display: none;
        }
        .col-1{
          position: relative;
          padding-right:40px;
          cursor: pointer;
          span{
            padding: 5px 0;
          }
          &:hover{
            color: #f4e2be;
          }
        }
    }
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/EventMenuList.vue